<template>
  <div class="jump-cart">
      <van-nav-bar title="我的收藏" left-arrow fixed class="jump-nav-bar" @click-left="back" >
            <!-- <div slot="right" class="jump-nav-bar-rhd">
                 <i class="iconfont icon-sousuo"></i><span>管理</span> 
            </div> -->
      </van-nav-bar>
      <div class="jump-cart-body">
        <div class="jump-cart-body-hd"></div>
        
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadData"
      >        
        <van-swipe-cell :right-width="65" class="jump-cart-item-hd" v-for="(item,i) in goodsList">
          <van-row class="jump-cart-item" type="flex" >
              <van-col span="10" class="jump-cart-item-img">
                  <a :href="'#/gooddetail/'+item.goods_id"> <img :src="item.imgUrl" /></a>
              </van-col>
              <van-col span="14" class="jump-cart-item-warp">
                  <a :href="'#/gooddetail/'+item.goods_id"> <h4>{{item.goods_name}}</h4></a>
                  <p class="item-price" style="text-align: left">
                      <span v-if="item.goods_price=='0' || item.goods_price=='' || item.goods_price==null">面议</span>
                      <span v-else>￥{{item.goods_price}} </span>
                      <i class="iconfont icon-lajitong" @click="favoriteDel(item.id,i)"></i>
                      <i @click="addCart(item.goods_id)" class="iconfont icon-gouwuche" v-if="item.goods_type!=6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i>
                  </p>

              </van-col>
          </van-row>
          <span slot="right" class="item-det" @click="favoriteDel(item.id,i)">删除</span>
        </van-swipe-cell>

      </van-list>
      </div>
        <BackTop />
  </div>
</template>
<script>
import { NavBar, Row, Col,SwipeCell,List  } from "vant";

export default {
  name: "usercollect",
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [SwipeCell.name]: SwipeCell,
    [List.name]:List
  },
  data() {
    return {
      finished:false,
      loading:false,
      currentPage:1,
      pages:1,
      goodsList:[],
    };
  },
  methods: {
      back(){
          history.back();
      },
      addCart(goodsId){
        let that = this;
        that.$api.addCart(goodsId,1,1,
            successRes=>{
              that.$toast(successRes.msg);
              if(successRes.success){
              }else{
              }
          });
      },
      favoriteDel(id){
        let that = this;
          this.$api.post(that.jumuc.userCenter.favoriteDel,{'mulitId':id},
            successRes =>{
              that.$toast(successRes.msg)
              if(successRes.success){
                that.currentPage = 1;
                that.pages = 1;
                that.goodsList = [];
                that.loadData();
              }
            })
      },
      loadData(){
        if(this.currentPage > this.pages){
          this.finished = true;
          this.loading = false;
          return;
        }
        this.finished = false;
        this.loading = true;
        this.getGoodsList();
        
      },
      getGoodsList(){
        let that = this;
          this.$api.post(that.jumuc.userCenter.collectGoods,{'currentPage':that.currentPage},
            successRes =>{
              that.goodsList =  that.goodsList.concat(successRes.data.list);
              that.pages = successRes.data.pages;
              that.currentPage++;
              that.loading = false;
            })
      }
  },
  mounted() {
  }
};
</script>
<style lang="less" scoped>
@bule-thame: #3c6eeb;

body {
  background-color: #f7f7f7;
}
.jump-nav-bar-rhd{
    color: #fff;
    font-size: 16px;
    i{
      font-size: 18px;
    }
    span{
        margin-left: 10px;
    }
}
.jump-cart {


  .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }
  &-body {
    padding: 20px 10px 0;
    position: relative;
     &-hd{
       position: absolute;
       top: 0;
       left: 0;
       width: 100%;
       height: 80px;
       background-color: @bule-thame;
     }
  }
  &-item {
    align-items: center;
    padding: 15px;
    position: relative;
    .van-checkbox {
      height: 100%;
      line-height: 100%;
    }
    &-img {
      img {
        width: 90%;
      }
    }

    h4 {
      font-size: 14px;
      padding: 10px 0;
      color: #666;
    }
    &-warp {
      align-self: flex-start;
    }
    p {
      font-size: 14px;
        &.item-price {
            color: red;
            font-size: 16px;
                i{
                    font-size: 18px;
                    float: right;
                    color: #f5a623
                }
        }
    }
  }
  
  &-filter {
    padding: 10px;
    color: #fff;
    position: relative;
    &-item {
      font-size: 14px;
      i {
        vertical-align: -2px;
        padding-left: 3px;
      }
    }
  }
  .jump-cart-item-hd{

    border-radius: 20px;
    background-color: #fff;
    margin-bottom: 15px;
    .van-swipe-cell__right{
      background-color: #f00;
      color: #fff;
      width: 65px;
      text-align: center;
      span{
        display: inline-block;
        margin-top: 100%;
      }
    }
  }
}
</style>

